import React from'react';
import PeopleItemChanteurs from './PeopleItemChanteurs';
import People from './People';
import { Container, Row } from 'react-bootstrap';

const PeopleGridChanteurs = () => {
    
    return (
        <Container>
            <Row>
                {People.map((People) => (    
                    <PeopleItemChanteurs key={People.id} texte={People.texte} photo={People.photo} date={People.date} nom={People.nom} job={People.job} miniatures={People.miniatures} />
                ))}
            </Row>
        </Container>
                
    )
}

export default PeopleGridChanteurs;